import { FC } from "react";
import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";

const RechargeTriggerButton: FC<{ onClick: () => void; label?: string }> = ({ onClick, label }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const getAmount = Form.useWatch("getAmount", form);

  return (
    <Form.Item shouldUpdate noStyle>
      {() => {
        const hasErrors = form.getFieldsError().some((f) => f.errors.length > 0);
        const disabled = hasErrors || !getAmount;
        return (
          <Button
            size="large"
            block
            className={disabled ? "font-semibold!" : "font-semibold! bg-background-primary! text-font-inverted!"}
            disabled={disabled}
            onClick={onClick}
          >
            {label ?? t("Topup.recharge")}
          </Button>
        );
      }}
    </Form.Item>
  );
};

export default RechargeTriggerButton;
